import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=525bd3bc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525bd3bc')) {
      api.createRecord('525bd3bc', component.options)
    } else {
      api.reload('525bd3bc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=525bd3bc&", function () {
      api.rerender('525bd3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22J9akXhfqEUQ/JS/pricehelp.vue"
export default component.exports